import React from 'react';

export const useMouseEnterLeaveEvents = ({
  forwardRef,
  onMouseEnter,
  onMouseLeave,
} = {}) => {
  const ref = React.useRef(null);

  React.useEffect(() => {
    // Get ref for effect
    const node = ref.current;
    if (!node) {
      return () => undefined;
    }

    // Patch forwarded ref
    if (forwardRef && typeof forwardRef === 'function') {
      forwardRef(node);
    } else if (forwardRef) {
      // eslint-disable-next-line no-param-reassign
      forwardRef.current = node;
    }

    const mouseEnter = (e) => onMouseEnter && onMouseEnter(e);
    const mouseLeave = (e) => onMouseLeave && onMouseLeave(e);

    // Component did mount
    node.addEventListener('mouseenter', mouseEnter);
    node.addEventListener('mouseleave', mouseLeave);

    // Component did unmount
    return () => {
      node.removeEventListener('mouseenter', mouseEnter);
      node.removeEventListener('mouseleave', mouseLeave);
    };
  }, [forwardRef, onMouseEnter, onMouseLeave]);

  return [ref];
};
